import { render, staticRenderFns } from "./testApplication.vue?vue&type=template&id=15da5cab"
import script from "./testApplication.vue?vue&type=script&lang=js"
export * from "./testApplication.vue?vue&type=script&lang=js"
import style0 from "./testApplication.vue?vue&type=style&index=0&id=15da5cab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports